export const GET_ANALYSIS = 'GET_ANALYSIS';
export const GET_STORY = 'GET_STORY';
export const BOOKSHARE_OAUTH = "https://auth.bookshare.org/v2/oauth/authorize";